import * as React from 'react';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-apollo';
import { Button, Form } from 'react-bootstrap';
import { GET_FARMS, GET_GROWERS2 } from '../../../../../../queries';
import { GetFarms, GetGrowers } from '../../../../../../__generated__/types';

import { useStore } from "../../../../providers/AppProvider";
import { Farm, Grower } from '../../../../types/types';
import { getYears } from '../../../../utils/misc';
import { useFieldStore } from '../../providers/FieldProvider';

type FieldDownloadProps = {
    onCancel: () => void
}

const FieldDownload = ({onCancel}: FieldDownloadProps) => {
    const { state: { crops }, socket, startSocket, messageFromWorker } = useStore();
    const { filters, updateFilter } = useFieldStore();

    const { data: growerData } = useQuery<GetGrowers>(GET_GROWERS2);
    const { data: farmData } = useQuery<GetFarms>(GET_FARMS);

    const [growers, setGrowers] = useState<Grower[]>([]);
    const [farms, setFarms] = useState<Farm[]>([]);
    const [years, setYears] = useState<number[]>([]);

    const [localFilter, setLocalFilter] = useState({...filters});

    useEffect(() => {
        setGrowers(growerData ? growerData.landscan_growers.map(g => { 
            return {
                id: g.grower_id,
                name: g.name,
                description: g.description
            } as Grower
        }) : []);
    }, [growerData]);

    useEffect(() => {
        startSocket();
    }, []);

    useEffect(() => {
        setFarms(farmData ? farmData.landscan_farms.map(f => { 
            return {
                id: f.farm_id,
                grower_id: f.grower_id,
                name: f.name,
                description: f.description
            } as Farm
        }) : []);
    }, [farmData]);

    useEffect(() => {
        setLocalFilter({...filters});
        console.log("081723 filters", filters)
    }, [filters])

    useEffect(() => {
        console.log("081723 localFilter", localFilter)
    }, [localFilter])

    const onChange = (e: any) => {
        setLocalFilter({
            ...localFilter, 
            [e.target.name]: [e.target.value]
        });
    }

    const clearFilter = (key:string) => {
        setLocalFilter({
            ...localFilter, 
            [key]: []
        });
    }

    const applyDownload = () => {
        //updateFilter(localFilter);
        console.log("083023 socket", socket)
        socket.emit('chat', "Ship It");
        /*
        syncarto-chatbot-1  | 63e2ddf0-b67d-11ec-ba45-024a2a01d41b/63e2ddf0-b67d-11ec-ba45-024a2a01d41b-1693430087510
        syncarto-chatbot-1  | ShipIt
        syncarto-chatbot-1  | ShipIt sessionId:  63e2ddf0-b67d-11ec-ba45-024a2a01d41b/63e2ddf0-b67d-11ec-ba45-024a2a01d41b-1693430087510
        syncarto-chatbot-1  | ShipIt socket.sessionData:  { orgId: '63e2ddf0-b67d-11ec-ba45-024a2a01d41b' }
        ----
        syncarto-chatbot-1  | 63e2ddf0-b67d-11ec-ba45-024a2a01d41b/d928b2cb-ace4-4870-b6a2-5d67380db26c-Xu59-Kj6
        syncarto-chatbot-1  | ShipIt
        syncarto-chatbot-1  | ShipIt sessionId:  63e2ddf0-b67d-11ec-ba45-024a2a01d41b/d928b2cb-ace4-4870-b6a2-5d67380db26c-Xu59-Kj6
        syncarto-chatbot-1  | ShipIt socket.sessionData:  {
        syncarto-chatbot-1  |   orgId: '63e2ddf0-b67d-11ec-ba45-024a2a01d41b',
        syncarto-chatbot-1  |   AOI: [
        syncarto-chatbot-1  |     36.798304603263816,
        syncarto-chatbot-1  |     36.79841926917612,
        syncarto-chatbot-1  |     -120.19295180438748,
        syncarto-chatbot-1  |     -120.19270453007358
        syncarto-chatbot-1  |   ],
        syncarto-chatbot-1  |   AOIDisplayName: 'map-extent'
        syncarto-chatbot-1  | }
        syncarto-chatbot-1  | Success bc13780f-6681-42d7-9911-9cf223662ea1
        */

    }

    const cancelDownload = () => {
        onCancel();
    }

    console.log("081723 localFilter", localFilter)
    return (
        <div className="mb-2 card">
        <div className="p-2 card-body">
            <h5 className="text-base">Clip and Download</h5>
            {/*
            <div className="d-flex mt-2">
                <Form.Control
                    as="select"
                    size="sm"
                    name="grower_id"
                    value={localFilter && localFilter.grower_id.length ? localFilter.grower_id[0].toString() : ''}
                    onChange={(e:any) => onChange(e)}
                >
                    <option value="" label="Layers to clip" className="" disabled />
                    {growers.map(option => {
                        return <option key={option.id} value={option.id}>{option.name}</option>
                    })}
                </Form.Control>
                { localFilter.grower_id.length > 0 &&                 
                    <Button variant="secondary" size="sm" className="ml-2" onClick={(e:any) => clearFilter("grower_id")}>X</Button>
                }
            </div>
           
            <div className="d-flex mt-2">
                <Form.Control
                    as="select"
                    size="sm"
                    name="farm_id"
                    value={localFilter && localFilter.farm_id.length ? localFilter.farm_id[0].toString() : ''}
                    onChange={(e:any) => onChange(e)}
                >
                    <option value="" disabled>Clip extent</option>
                    {farms.map(option => {
                        return <option key={option.id} value={option.id}>{option.name}</option>
                    })}
                </Form.Control>
                { localFilter.farm_id.length > 0 &&                 
                    <Button variant="secondary" size="sm" className="ml-2" onClick={(e:any) => clearFilter("farm_id")}>X</Button>
                }
            </div>
            */}
            <div 
                className="d-flex mt-2 chat-message"
                style={{
                    fontSize:'8pt',
                }}
            >
                {messageFromWorker.chat}
            </div>
            <div 
                className="d-flex mt-2"
                style={{
                    fontSize:'8pt',
                }}
                dangerouslySetInnerHTML={{ __html: messageFromWorker.shipment }} />
            <Button variant="primary" className="mt-2" size="sm" onClick={applyDownload} disabled={messageFromWorker.processing}>
                Start
            </Button>
            <Button variant="secondary" className="mt-2 ml-2" size="sm" onClick={cancelDownload}>
                Close
            </Button>
        </div>
        </div>
    );
}

export default FieldDownload;